import { getLocalTimeZone, now } from "@internationalized/date"
import { Link, useMatchRoute, useSearch } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"

import Logo from "@/assets/logos/inflow/InFlow-Logo.svg"
import Separator from "@/globalComponents/atoms/Separator"
import Text from "@/globalComponents/atoms/Text"
import { stripEmptyParams } from "@/utilities/etc"

function Footer() {
  const matchRoute = useMatchRoute()
  const params = matchRoute({ to: "/qr/$qrLookupID", fuzzy: true })
  const search = useSearch({ strict: false })
  const { t } = useTranslation()

  const scannedAreaParams = params
    ? {
        qrLookupID: params.qrLookupID,
      }
    : search?.qrLookupID
      ? {
          qrLookupID: search.qrLookupID,
        }
      : {}

  return (
    <footer>
      <div className="footer-logo">
        <Logo />
      </div>
      <div className="footer-links">
        <Link
          to="/privacy-policy"
          search={stripEmptyParams(scannedAreaParams)}
          className="body--3"
          preload={false}
        >
          {t("navigation.footer.privacyPolicy")}
        </Link>
        <Separator orientation="vertical" />
        <Link
          to="/terms-of-use"
          search={stripEmptyParams(scannedAreaParams)}
          className="body--3"
          preload={false}
        >
          {t("navigation.footer.termsOfUser")}
        </Link>
      </div>
      <div>
        <Text level={3} className="center">
          {t("navigation.footer.copyright", {
            currentYear: now(getLocalTimeZone()).year,
          })}
        </Text>
      </div>
    </footer>
  )
}

export default Footer
